var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rule-item"},[_c('div',{staticClass:"rule-title"},[_vm._v(_vm._s(_setup.title))]),_vm._v(" "),_c('div',{staticClass:"rule-content"},[_vm._v(_vm._s(_setup.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }